import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { myHeaders } from "./CommonHeader";

export const SendCartAction = createAsyncThunk(
  "SendCartAction",
  async (data1, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        process.env.REACT_APP_BackEndIP+"/CartAction",
        {
          Action: data1[0],
          UID: data1[1],
        },
        {
          headers: myHeaders(),
        }
      );
      return data;
    } catch (error) {
      console.error("!!!", error);
      if (error?.response?.status > 399 || error.code === "ERR_NETWORK") {
        localStorage.clear();
        window.location.assign("/");
      }
    }
  }
);

const CartSlice = createSlice({
  name: "Cart",
  initialState: {
    isLoading: "hide",
    isEmpty: "hide",
    isFilled: "",
    data: [],
    data2: [],
    isError: "hide",
  },
  reducers: {
    UpdateCartData2Action(state, action) {
      for (const [key, value] of Object.entries(action.payload)) {
        state.data2[key] = value;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(SendCartAction.fulfilled, (state, action) => {
        state.isLoading = "hide";
        state.isEmpty = "hide";
        state.isFilled = "";
        if (action.payload === "[NoDataFound]") {
          state.data = [];
          state.data2 = [];
          state.isEmpty = "";
          state.isFilled = "hide";
        } else {
          state.data = action.payload.slice(0,-1);
          state.data2 = action.payload.slice(-1)[0];
        }
        state.isError = "hide";
      })
      .addCase(SendCartAction.pending, (state, action) => {
        state.isLoading = "";
        state.isEmpty = "hide";
        state.isFilled = "";
        state.isError = "hide";
      })
      .addCase(SendCartAction.rejected, (state, action) => {
        state.isError = "";
        state.isEmpty = "hide";
        state.isFilled = "";
        state.isLoading = "hide";
      });
  },
});

export const { UpdateCartData2Action } = CartSlice.actions;
export default CartSlice.reducer;
